module.exports = __webpack_public_path__ + "img/img4.e8feceaf.png";